import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validates that a `MM/YY` expiry date is well formed and not in the past.
 * Usable directly as a reactive-forms validator function.
 */
export function expiryDateValidator(
  control: AbstractControl
): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const [monthStr, yearStr] = String(control.value).split('/');
  const month = parseInt(monthStr, 10);
  const year = parseInt(yearStr, 10);

  if (isNaN(month) || isNaN(year) || month < 1 || month > 12) {
    return { invalidFormat: true };
  }

  // Last moment of the expiry month.
  const expiryDate = new Date(2000 + year, month, 0, 23, 59, 59);
  return expiryDate >= new Date() ? null : { expired: true };
}
